import { render, staticRenderFns } from "./TemplateName.vue?vue&type=template&id=cd0f1242&"
import script from "./TemplateName.vue?vue&type=script&lang=js&"
export * from "./TemplateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports